import { render } from "./BTooltip.vue?vue&type=template&id=b235d4f2"
import script from "./BTooltip.vue?vue&type=script&lang=js"
export * from "./BTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__